import { Component, h, Prop, Host } from "@stencil/core";

@Component({
    tag: "ux-w-link-item",
    styleUrl: "link-item.scss",
    shadow: false
})
export class TrackLinkItem {
    /** Text above the button link */
    @Prop() headline: string = "";
    /** link for the button link */
    @Prop() link: string = "";
    /** Text on the button link */
    @Prop() linkLabel: string = "";
    /** Icon name */
    @Prop() icon: string = "";
    /** Icon name for button (Icon is inserted after the button text) */
    @Prop() buttonIcon: string = "";

    render() {
        const baseClass = "ux-w-link-item";
        const { headline, link, linkLabel, icon, buttonIcon } = this;

        return (
            <Host class={baseClass}>
                <div class={`${baseClass}__inner`}>
                    <ux-icon class={`${baseClass}__icon`} name={icon} />
                    <div class={`${baseClass}__headline`}>{headline}</div>
                    <ux-button href={link}>
                        {linkLabel}{" "}
                        {buttonIcon !== "" && (
                            <ux-icon slot="icon" name={buttonIcon} />
                        )}
                    </ux-button>
                </div>
            </Host>
        );
    }
}
